import { Col, Row } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { CheckListMiddleware } from "../../../../Store/Middlewares/CheckListMiddleware";
import dummy from "../../../../assets/dummy.jpg";
import { SearchInput, SubmitButton, TextComponent } from "../../../../components";
import styles from "../EventsCalendar.module.css";

const ShareChecklistModal = ({ onPressSend }) => {
  const YourVendorList = useSelector(
    (state) => state?.VendorReducer?.YourVendors
  );
  const YourVendorListPagination = useSelector(
    (state) => state?.VendorReducer?.YourVendorsPagination
  );

  const [search, setSearch] = useState("");
  const { state } = useLocation();
  const dispatch = useDispatch();

  const timeout = useRef();

  useEffect(() => {
    getVendor();
  }, []);

  const getVendor = () => {
    let data = {
      event_id: state?.eventData?.id,
      category_id: undefined,
      vendor_name: "",
      next_page_url: undefined,
    };
    dispatch(CheckListMiddleware.getEventVendors(data));
    // .then(() => setRefreshVendor(false))
    // .catch(() => setRefreshVendor(false));
  };

  const onSearchVendor = (val) => {
    setSearch(val);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      let data = {
        event_id: state?.eventData?.id,
        category_id: undefined,
        vendor_name: val,
        next_page_url: undefined,
      };
      dispatch(CheckListMiddleware.getEventVendors(data));
    }, 1500);
  };

  const onPressRenderMoreContent = () => {
    let data = {
      event_id: state?.eventData?.id,
      category_id: undefined,
      vendor_name: search,
      next_page_url: YourVendorListPagination?.links?.next,
    };
    dispatch(CheckListMiddleware.getEventVendors(data));
  };

  console.log("YourVendorList", YourVendorList);

  return (
    <Row className={styles.modalContentRow}>
      <TextComponent textClass={styles.modalText}>Send to</TextComponent>
      <SearchInput
        placeholder="Search"
        value={search}
        onChange={(e) => onSearchVendor(e.target.value)}
      />
      <Col xs={24} className={styles.vendorList}>
        {YourVendorList.map((person) => (
          <Row className={styles.personRow}>
            <Col xs={6}>
              <img
                className={styles.avatarImg}
                src={person?.image ? person.image : dummy}
                alt={person?.name + " image"}
              />
            </Col>
            <Col xs={12}>
              <TextComponent textClass={styles.personName}>
                {person?.name}
              </TextComponent>
              <TextComponent textClass={styles.personJob}>
                {person?.service_category_name}
              </TextComponent>
            </Col>
            <Col xs={6}>
              <SubmitButton
                title="Send"
                btnClass={styles.modalBtn}
                onClick={() => onPressSend(person?.id)}
              />
            </Col>
          </Row>
        ))}
        {YourVendorListPagination?.links?.next && (
          <div className={styles.loadDiv}>
            <SubmitButton
              title="Load More"
              btnClass={styles.loadBtn}
              onClick={onPressRenderMoreContent}
            />
          </div>
        )}
      </Col>
    </Row>
  );
};

export default ShareChecklistModal;
